export const HOURS_TO_EXPIRY = 4;
export const COOKIE_NAME = "idwalcookie" + process.env.REACT_APP_ASIMS_ENV;
